import React, { useState } from 'react';
import { MoreVertical, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';

interface DeleteSolutionMenuProps {
  solutionId: string;
  solutionName: string;
  solutionDetails: any;
  onDeleteSuccess: () => void;
}

const DeleteSolutionMenu = ({ 
  solutionId, 
  solutionName, 
  solutionDetails,
  onDeleteSuccess 
}: DeleteSolutionMenuProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteDialog(true);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="ghost" 
            size="sm"
            className="h-9 w-9 p-0"
            aria-label="More options"
          >
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem
            onClick={handleDeleteClick}
            className="text-red-600 focus:text-red-600 focus:bg-red-50"
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Request Deletion
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DeleteConfirmationDialog
        isOpen={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        solutionId={solutionId}
        solutionName={solutionName}
        solutionDetails={solutionDetails}
        onDeleteSuccess={() => {
          setShowDeleteDialog(false);
          onDeleteSuccess();
        }}
      />
    </>
  );
};

export default DeleteSolutionMenu; 